/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from './TextInput';
import { useValidationMessagingArgs, ValidationStates } from './ValidationMessages';

interface NameProps {
    initialValue?: string;
}

const verification: useValidationMessagingArgs = {
    applicableStates: [ValidationStates.MissingRequired],
};

export const Name: React.FC<NameProps> = ({ initialValue }) => {
    const { t } = useTranslation(['common']);

    return (
        <TextInput
            formFieldId="name"
            isRequired
            inputValidation={verification}
            label={t('common:name')}
            name="Name"
            initialValue={initialValue}
        />
    );
};
